export const FilterCategory = (label, datas, id) => {
    const collection = [];
    const map = new Map();
    const sortDatas = (datas) => {
        datas.sort((a, b) => {
            if (a.cslug < b.cslug) return -1;
            if (a.cslug > b.cslug) return 1;
            return 0;
        });
    }
    if (datas.errno) return collection;
    switch (label) {
        case 'home':
            for (const el of datas) {
                if (!map.has(el.cslug)) {
                    map.set(el.cslug, true);
                    collection.push({
                        cid: el.cid, cname: el.cname, cslug: el.cslug, croute: el.croute, ccode: el.ccode
                    });
                }
            }
            collection.push(
                { cid: 10, cname: 'Archives', cslug: 'archives', croute: '/archives-des-attractions', ccode: 'fa fa-database ' },
                { cid: 11, cname: 'Rendez-vous', cslug: 'rendez-vous', croute: '/rendez-vous', ccode: 'fa fa-calendar' }
            );
            sortDatas(collection);
            break;
        case 'park':
            for (const el of datas) {
                if (!map.has(el.cslug) && el.pid === id) {
                    map.set(el.cslug, true);
                    collection.push({
                        cid: el.cid, cname: el.cname, cslug: el.cslug,
                        ccode: el.ccode, croute: el.croute
                    });
                }
            }
            sortDatas(collection);
            break;
        case 'univers':
            for (const el of datas) {
                if (!map.has(el.cslug) && el.uid === id) {
                    map.set(el.cslug, true);
                    collection.push({
                        cid: el.cid, cname: el.cname, cslug: el.cslug,
                        ccode: el.ccode, croute: el.croute
                    });
                }
            }
            sortDatas(collection);
            break;
        default:
            return;
    }
    return collection;
}

